import { computed } from "vue"
import { useAuthStore } from "@/stores/auth"
import { useEventsStore } from "@/stores/apps/events"
import {
	DEFAULT_ORGANIZATION_NAME,
	resolveOrganizationLogo,
	resolveOrganizationName,
	type OrganizationBrand,
} from "@/utils/organizationLogo"

function pickOrganization(): OrganizationBrand {
	const eventsStore = useEventsStore()
	const authStore = useAuthStore()
	// From `/game/:org_api_key` or synced when an event is loaded (anonymous players)
	if (eventsStore.gameOrganization) return eventsStore.gameOrganization
	const fromEvent = (eventsStore.eventSelected as { organization?: OrganizationBrand } | null)
		?.organization
	if (fromEvent) return fromEvent
	return (authStore.full_user as { organization?: OrganizationBrand } | null)?.organization
}

/** Shared org brand (name + logo) from current event or logged-in user. */
export function useOrganizationBrand() {
	const organization = computed(() => pickOrganization())

	const organizationName = computed(() => resolveOrganizationName(organization.value))

	const fallbackLogo = computed(() => resolveOrganizationLogo(organization.value))

	return {
		organization,
		organizationName,
		fallbackLogo,
		defaultName: DEFAULT_ORGANIZATION_NAME,
	}
}
